import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { PicklistService } from 'src/app/modules/core/services/picklist/picklist.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-multi-picklist-cell',
    templateUrl: './multi-picklist-cell.component.html',
    styleUrls: ['./multi-picklist-cell.component.scss'],
    standalone: false
})
export class MultiPicklistCellComponent implements OnInit {
  value: any;

  constructor(private translate: TranslateService, private picklistService: PicklistService, private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);
    const selectedValues = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    this.value = '';
    if (!!selectedValues) {
      this.picklistService.getPicklistValues(field)
      .pipe(take(1))
      .subscribe(picklistValues => {
        selectedValues.map(val => {
          const selectedPicklistItem = picklistValues?.find(pv => pv.uId === val);
          if (!!selectedPicklistItem) {
            this.value += this.value.length > 0 ? `, ${selectedPicklistItem.value}` : selectedPicklistItem.value;
          }
        });
        this.changeDetector.markForCheck();
      });
    }
  }
}
